// The registry of fact extractors, run in this order on every scanned game.
// A new kind of fact: a new file in this folder (its extractor), its fields
// on `GameFacts` in `@chess/api-model` (`facts.ts`), and one line here.
import type { FactExtractor } from '../extractor.ts';
import { stageScores } from './stage-scores.ts';
import { judgements } from './judgements.ts';
import { stageErrors } from './stage-errors.ts';
import { stageTurns } from './stage-turns.ts';
import { endingBlunders } from './ending-blunders.ts';
import { stageCurves } from './stage-curves.ts';
import { mistakes } from './mistakes.ts';
import { accuracy } from './accuracy.ts';
import { timeSlip } from './time-slip.ts';
import { endingCase } from './ending-case.ts';
import { middlegameResult } from './middlegame-result.ts';
import { groundCause } from './ground-cause.ts';
import { conversion } from './conversion.ts';
import { openingSlips } from './opening-slips.ts';
import { openingMoves } from './opening-moves.ts';
import { middlegamePositions } from './middlegame-positions.ts';

export const FACT_EXTRACTORS: readonly FactExtractor[] = [
  stageScores,
  judgements,
  stageErrors,
  stageTurns,
  endingBlunders,
  stageCurves,
  mistakes,
  accuracy,
  timeSlip,
  endingCase,
  middlegameResult,
  groundCause,
  conversion,
  openingSlips,
  openingMoves,
  middlegamePositions,
];
